import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AgendaFileCard from "../Card/AgendaFileCard";
import { useSelector } from "react-redux";

function AgendaFileDialog({ onClose, open, agendaFileList, setAgendaFileList }) {
    return (
        <Dialog onClose={(_, reason) => { if (reason !== 'backdropClick') onClose(); }} open={open} fullWidth maxWidth="md">
            <DialogTitle sx={{  }}>
                {'Dosya İşlemleri (' + agendaFileList.length + ' Dosya)'}
            </DialogTitle>

            <DialogContent dividers sx={{  }}>
                <AgendaFileCard
                    agendaFileList={agendaFileList}
                    setAgendaFileList={setAgendaFileList}
                    onClose={onClose}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    size='small'
                    color="error"
                    onClick={onClose}
                    sx={{  }}
                >
                    Kapat
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default AgendaFileDialog;

